// TMC系统相关api
/* eslint-disable */
export default {
    basePath: process.env.VUE_APP_H5_CENTER,
    apiList: {
        // 查询缓存
        H5_INQUIRY_GET_CACHE: '/api/commonRp/h5inquiry/getCache',
        // 创建订单
        H5_INQUIRY_H5_ADD_ORDER: '/api/commonRp/h5inquiry/h5AddOrder',
        // 创建视频订单
        RP_ORDER_CREATE_ORDER_H5: 'api/commonRp/rpOrder/createOrderH5',
        // 身份证实名认证
        PERSON_ID_CARD_VERIFICATION: '/api/apirp/person/idCardVerification',
        // 轮询查询订单状态
        H5_INQUIRY_GET_ORDER_STATUS_INFO: '/api/commonRp/h5inquiry/getOrderStatusInfo',
        // 查询医院员工信息（有医生 医助 jobType 字段）
        INTERFACE_GET_DOCTOR_INFO: 'api/peachUser/hospitalStaff/getDoctorInfoByStaffID',
        // 实名认证查询接口
        // PERSON_ID_CARD_VERIFICATION: "/api/apirp/person/idCardVerification",
        // 根据orderID查询患者信息
        H5_INQUIRY_PATIENT_INFO: 'api/apirph5inquiry/patientInfo',
        // 归毂视频接口
        RP_ORDER_CREATE_H5_ORDER_WITH_INFO: 'api/commonRp/rpOrder/createH5OrderWithInfo',
        //测试创单
        TEST_ADD_ORDER: '/openRemoteInquiry/order/applyForSxf',
        //查询订单信息
        GET_INQUERY_DETAIL_INFO: '/openRemoteInquiry/order/getCacheForSq',
        //根据 IMID 查询医生信息
        GET_DOCTOR_INFO_BY_ID: '/openRemoteInquiry/order/getDoctorInfoByKeyID',
        //自动创单
        AUTO_ORDER: "/openRemoteInquiry/order/apply",
        // 结束问诊请求地址接口
        H5_INQUIRY_POST_CHECKTHIRD: '/openRemoteInquiry/order/getRequireThirdUrl',
        // 结束问诊请求地址接口
        H5_INQUIRY_GET_SDKAPPID: '/openRemoteInquiry/tencent/getIMSdkInfo',
        // 检查处方状态
        checkRpStatus: '/openRemoteInquiry/order/checkRpStatus',
        // 支付宝渠道患者回复（messageType: 0 文本，1 图片）
        H5_INQUIRY_SEND_PATIENT_REPLY: '/openRemoteInquiry/order/sendPatientReply',
    },
}
